"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getAuthTechnicalErrorMessage = exports.updateEmailWithIbanOrBillingState = exports.isExpired = exports.getRefreshExpiresInSecondesData = exports.getExpiresInSecondesData = exports.getUpdateEmailNewsLetterData = exports.getUpdateEmailData = exports.getCreateAccountData = exports.getRefreshToken = exports.getAccessToken = exports.getAuthenticatedUser = exports.getTempEmail = exports.getUserLoginState = exports.getAuthState = void 0;
function getAuthState(states) {
    return states.auth;
}
exports.getAuthState = getAuthState;
function getUserLoginState(states) {
    return states.auth.data.login;
}
exports.getUserLoginState = getUserLoginState;
function getTempEmail(states) {
    return states.auth.data.email;
}
exports.getTempEmail = getTempEmail;
function getAuthenticatedUser(states) {
    return states.auth.userAuthentified;
}
exports.getAuthenticatedUser = getAuthenticatedUser;
function getAccessToken(states) {
    return states.auth.data.accessToken;
}
exports.getAccessToken = getAccessToken;
function getRefreshToken(states) {
    return states.auth.data.refreshToken;
}
exports.getRefreshToken = getRefreshToken;
function getCreateAccountData(states) {
    return states.auth.createAccountData;
}
exports.getCreateAccountData = getCreateAccountData;
function getUpdateEmailData(states) {
    return states.auth.updateEmailData;
}
exports.getUpdateEmailData = getUpdateEmailData;
function getUpdateEmailNewsLetterData(states) {
    return states.auth.updateEmailNewsLetter;
}
exports.getUpdateEmailNewsLetterData = getUpdateEmailNewsLetterData;
function getExpiresInSecondesData(states) {
    return states.auth.data.expiresInSecondes;
}
exports.getExpiresInSecondesData = getExpiresInSecondesData;
function getRefreshExpiresInSecondesData(states) {
    return states.auth.data.refreshExpiresInSecondes;
}
exports.getRefreshExpiresInSecondesData = getRefreshExpiresInSecondesData;
function isExpired(states) {
    var authState = getAuthState(states);
    if (authState.data.accessToken && authState.data.expireDate) {
        return (new Date(authState.data.expireDate).getTime() < new Date().getTime());
    }
    return true;
}
exports.isExpired = isExpired;
function updateEmailWithIbanOrBillingState(states) {
    var authState = getAuthState(states);
    return authState.updateEmailWithIbanOrBilling;
}
exports.updateEmailWithIbanOrBillingState = updateEmailWithIbanOrBillingState;
/**
 * Récupère le message d'erreur technique
 * @param states Tous les state de l'application
 */
function getAuthTechnicalErrorMessage(states) {
    return states.auth.technicalErrorMessage;
}
exports.getAuthTechnicalErrorMessage = getAuthTechnicalErrorMessage;
